import { useState, useContext, useCallback } from 'react'
import styled from 'styled-components'
import { t } from 'ttag'
import PropTypes from 'prop-types'

import { SDB } from '@h2/components/colors'
import { features } from '@h2/components/media'
import { Switch } from '@h2/components/inputs/switch'
import { InfoCircleIcon } from '@h2/components/icons/infoCircle'
import { Flex } from '@h2/components/layout/flex'

import { Context } from './context'
import { ViewSwitcherModal } from './viewSwitcherModal'

import { VIEW_MODE_BASIC } from '../../constants'
import { useNavigator } from '../hooks/useNavigator'

const FlexWrap = styled(Flex)`
  display: none;

  @media (${features.minWidth.laptop}) {
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
    justify-content: ${({ align }) => (align === 'left' ? 'flex-start' : 'center')};
    width: 100%;

    > span[role='img'] {
      position: relative;
      top: -5px;
      left: 5px;
    }
  }
`
const ViewSwitcher = ({ align = 'center' }) => {
  const { viewMode, userProfile, isNavianceElementary, handleOnViewChange } =
    useContext(Context)
  const earlyDashboardActive = userProfile?.earlyDashboardActive ?? false
  const navigator = useNavigator()
  const [showModal, setShowModal] = useState(false)
  const viewSwitch = useCallback(() => {
    handleOnViewChange()

    /*
     * Since we don't want early educators to end up in a mixed view, we will redirect home and switch
     * the view
     */
    if (isNavianceElementary && !earlyDashboardActive) {
      navigator('/')
    }
  }, [navigator, handleOnViewChange, isNavianceElementary, earlyDashboardActive])

  return (
    <FlexWrap
      isVisible={userProfile?.isNavigator || userProfile?.hasManager}
      align={align}>
      <Switch
        offColor={SDB}
        labelPosition="both"
        label={[t`Navigator Mode`, t`Explorer Mode`]}
        isOn={viewMode === VIEW_MODE_BASIC}
        onChange={viewSwitch}
      />
      <InfoCircleIcon size="tiny" onClick={() => setShowModal(true)} />
      {showModal && <ViewSwitcherModal onClose={() => setShowModal(false)} />}
    </FlexWrap>
  )
}

ViewSwitcher.propTypes = {
  align: PropTypes.oneOf(['left', 'center'])
}

export { ViewSwitcher }
